import React from 'react'
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// An unknown address. In the app's own colours rather than the default
// profile theme, which made a missing page look like a broken profile.
// src/profileView.js renders the same markup for the server's 404.
const NotFound = () => {
  const [t] = useTranslation();
  return (
    <main className="not-found">
      <div className="not-found__card">
        <p className="not-found__code">404</p>
        <h1 className="not-found__title">{t('profileNotExist')}</h1>
        <p className="not-found__text">{t('profileNotExistHint')}</p>
        <Link className="not-found__cta" to="/signup">{t('createYourPage')}</Link>
        <a className="not-found__home" href="/">link.piyanos.com</a>
      </div>
    </main>
  )
}

export default NotFound
